export const reviewKey = {
  all: ['review'] as const,
  get: (id: string) => [...reviewKey.all, id] as const,
  reviewableOrderlines: (order_group_number: string) =>
    [...reviewKey.all, order_group_number] as const,
};
